<label
    class="custom-swatch"
    [class.current]="current()"
    [class.disabled]="disabled()"
    [attr.aria-label]="label()"
    [raEditTooltip]="{ text: label(), position: 'top' }">
    <input
        type="color"
        [value]="value()"
        [disabled]="disabled()"
        (pointerdown)="$event.stopPropagation()"
        (input)="onInput($event)"
        (change)="onChange($event)" />
</label>
